import type { JSX } from 'react';
import styles from './ModalButton.module.css';
import type { ModalButtonProps } from './ModalButton.types';

const ModalButton = ({
  text,
  onClick,
  disabled,
}: ModalButtonProps): JSX.Element => {
  return (
    <button
      className={`${styles.modalButton} ${disabled ? styles.disabled : ''}`}
      disabled={disabled}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default ModalButton;
